module.exports = __webpack_public_path__ + "img/f233185.png";